export default "__VITE_ASSET__Cddmw1d7__"